<template>
  <div style="content-visibility: hidden;">
    <div id="outer-wrapper-vt" class="container-fluid">
      <div class="row">
        <div
          class="col-md-3"
          v-for="(item,index) in sortedTrayData"
          :key="index"
        >
          <div>
            <div class="compare-div-part mb-2">
              <div class="pop-up-compare-div-image mb-3"
                :style="{ width:'243.83px',  height:'243.83px', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }"
              >
                <img v-if="item.inventoryType.toLowerCase() != paint.toLowerCase() && item.inventoryType.toLowerCase() != pom.toLowerCase()"
                  :alt="item.colorNumber"
                  :src="item.imagePath.includes('?') ? item.imagePath : item.imagePath + `?t=${Math.random()}`"
                  crossOrigin="anonymous"
                  class="w-100"
                />
                <img v-if="item.inventoryType.toLowerCase() == pom.toLowerCase()"
                  :alt="item.colorNumber"
                  :src="item.imagePath.includes('?') ? item.imagePath : item.imagePath + `?t=${Math.random()}`"
                  crossOrigin="anonymous"
                />
                <div :style="{backgroundColor:item.hexColor, width:'243.83px',  height:'243.83px'}" v-else></div>
              </div>
              <dl class="description text-uppercase">
                <div>
                  <dt>
                    <u>{{ item.colorName }}</u>
                  </dt>
                  <dd>
                    {{ item.colorNumber }}
                  </dd>
                </div>
                <div>
                  <dt>
                    {{
                      $resourceString[
                        "product.details.specifications.product.style"
                      ]
                    }}
                  </dt>
                  <dd>
                    {{ item.sellingStyleName != undefined ? item.sellingStyleName : item.styleName }}
                  </dd>
                </div>
                <div class="specification-part" v-if="item.inventoryType.toLowerCase() === carpet.toLowerCase() || item.inventoryType.toLowerCase() === resilient.toLowerCase() ">
                    <h3 class="label my-2">
                      {{
                        $resourceString[
                          "product.details.specifications.specifications"
                        ]
                      }}
                    </h3>
                  <div>
                    <dt>
                      {{
                        $resourceString[
                          "product.details.specifications.product.type"
                        ]
                      }}
                    </dt>
                    <dd>
                      {{ item && item.inventoryType }}
                    </dd>
                  </div>
                  <div>
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.secondary.backing"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{ item.productDetails && item.productDetails.secondaryBacking }}
                      </dd>
                  </div>
                  <div>
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.construction"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{ item.productDetails && item.productDetails.construction }}

                      </dd>
                    </div>
                    <div>
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.wear.rating"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{ item.productDetails && item.productDetails.testResults && item.productDetails.testResults.tarrClassification }}
                      </dd>
                    </div>
                    <div>
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.dye.method"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{ item.productDetails && item.productDetails.dyeMethod }}
                      </dd>
                    </div>
                    <div>
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.fiber"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{ item.productDetails && item.productDetails.fiber }}
                      </dd>
                    </div>
                    <div v-if="item.productDetails && item.productDetails.areaPerCarton">
                      <dt>
                        {{
                          $resourceString[
                            "product.details.specifications.squareyards"
                          ]
                        }}
                      </dt>
                      <dd>
                        {{ item.productDetails &&
                          Math.round(
                            item.productDetails.areaPerCarton.metric.formattedValue * 100
                          ) / 100
                        }}
                      </dd>
                    </div>
                    <div class="pdq-part">
                    <h3 class="label my-2">
                      {{
                        $resourceString[
                          "product.details.specifications.pdq.details"
                        ]
                      }}
                    </h3>
                    <dt
                     v-if="item.productDetails && item.productDetails.pdqDetails"
                      class="pdq-name text-uppercase"
                      v-html="item.productDetails.pdqDetails"
                    ></dt>
                  </div>
                  <div class="sustain-part mb-3">
                    <h3 class="label my-2">
                      {{
                        $resourceString[
                          "product.details.specifications.sustainability"
                        ]
                      }}
                    </h3>
                    <dt>
                      {{
                        $resourceString[
                          "product.details.specifications.recyclability"
                        ]
                      }}
                    </dt>
                    <dd>
                      {{ item.productDetails && item.productDetails.recyclability }}
                    </dd>
                  </div>
                  <div class="third-party-part">
                    <h3 class="label my-2">
                      {{
                        $resourceString[
                          "product.details.specifications.third.party.certificates"
                        ]
                      }}
                    </h3>

                    <div
                      class="third-party-items mb-2"
                      v-for="attribute in item.productDetails && item.productDetails.attributes"
                      :key="attribute.name"
                    >
                      <dt v-if="attribute.pdfLink">
                        {{ attribute.name }}
                      </dt>
                      <dd v-if="attribute.pdfLink">
                        <u>
                          {{ attribute.status }}
                        </u>
                      </dd>
                    </div>
                    <div
                      class="third-party-items mb-2"
                      v-for="certification in item.productDetails && item.productDetails.certifications"
                      :key="certification.name"
                    >
                      <dt v-if="certification.pdfLink">
                        {{ certification.name }}
                      </dt>
                      <dd v-if="certification.pdfLink">
                        <u>
                          {{ certification.status }}
                        </u>
                      </dd>
                    </div>
                    

                  </div>
                </div>
              </dl>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
  return {
    paint: null,
    pom: null,
    resilient: null,
    carpet: null,
    customSortOrder: [],
  };
},

created() {
  this.paint = this.$resourceString['virtualtray.paint'];
  this.pom = this.$resourceString['virtualtray.pom'];
  this.resilient = this.$resourceString['common.Label.Resilient'];
  this.carpet = this.$resourceString['common.Label.Carpet'];
  // Define a custom sort order based on the 'name' property
  this.customSortOrder = [this.carpet, this.resilient, this.paint, this.pom];
},
  computed: {
    ...mapGetters({
      trayData: "virtualTray/trayDataDownload"
    }),

    sortedTrayData() {
      if(this.trayData != undefined && Object.values(this.trayData).length > 0){
        let customOrderLowerCase = this.customSortOrder.map(item => item.toLowerCase());
        // Convert the object into an array
        const trayDataArray = new Set(Object.values(this.trayData));
        // Clone the array to avoid mutating the original data
        const clonedTrayData = [...trayDataArray];
        // Sort the cloned array based on the custom sort order
        clonedTrayData.sort((a, b) => {
          const indexA = customOrderLowerCase.indexOf(a.inventoryType.toLowerCase());
          const indexB = customOrderLowerCase.indexOf(b.inventoryType.toLowerCase());
          return indexA - indexB;
        });
        return clonedTrayData;
      }
      else{
        return []
      }
    }
  },

};
</script>
